import { DateTime } from 'luxon';
import { RXServiceDispensingHistoryCustomerDetailModel } from '@common/models/RXServiceDispensingHistoryCustomerDetailModel';
import { RXServiceDispensingHistoryPetDetailModel } from '@common/models/RXServiceDispensingHistoryPetDetailModel';
import { StringUtility } from '@common/utils';

export interface IRXServiceDispensingHistoryItemModel {
  order_number: string;
  sku: string;
  sku_name: string;
  tracking_number: string;
  shipped_date: string | undefined;
  ordered_date: string | undefined;
  shipping_url: string;
  fulfillment_quantity: number;
  prescription_number: string;
  prescription_type: string;
  prescribing_vet_name: string;
  pet_details: RXServiceDispensingHistoryPetDetailModel | undefined;
  customer_details: RXServiceDispensingHistoryCustomerDetailModel | undefined;
}

export class RXServiceDispensingHistoryItemModel
  implements Record<keyof IRXServiceDispensingHistoryItemModel, any>
{
  order_number: string;
  sku: string;
  sku_name: string;
  tracking_number: string;
  shipped_date: DateTime | undefined;
  ordered_date: DateTime | undefined;
  shipping_url: string;
  fulfillment_quantity: number;
  prescription_number: string;
  prescription_type: string;
  prescribing_vet_name: string;
  pet_details: RXServiceDispensingHistoryPetDetailModel | undefined;
  customer_details: RXServiceDispensingHistoryCustomerDetailModel | undefined;

  constructor(params?: Partial<IRXServiceDispensingHistoryItemModel>) {
    this.order_number = _.defaultTo(params?.order_number, '');
    this.sku = _.defaultTo(params?.sku, '');
    this.sku_name = _.defaultTo(params?.sku_name, '');
    this.tracking_number = _.defaultTo(params?.tracking_number, '');
    this.shipping_url = _.defaultTo(params?.shipping_url, '');
    this.shipped_date = StringUtility.SanitizeDateTimeISO(params?.shipped_date);
    this.ordered_date = StringUtility.SanitizeDateTimeISO(params?.ordered_date);
    this.fulfillment_quantity = _.defaultTo(params?.fulfillment_quantity, 0);
    this.prescription_number = _.defaultTo(params?.prescription_number, '');
    this.prescription_type = _.defaultTo(params?.prescription_type, '');
    this.prescribing_vet_name = _.defaultTo(params?.prescribing_vet_name, '');
    this.pet_details = _.defaultTo(params?.pet_details, undefined);
    this.customer_details = _.defaultTo(params?.customer_details, undefined);
  }
}
